import React from 'react';

import Container from '../components/Container';
import Flex from '../components/Flex';
import Spacing from '../components/Spacing';
import Text from '../components/Text';
import Title from '../components/Title';

import constants from './constants';

const DownloadProgramSocialProof = () => (
  <Flex
    direction="col"
    justifyContent="center"
    className="p-10 min-h-full"
  >
    <Title className="font-semibold text-2xl leading-tight">
      Sé un experto agile con liderazgo y conocimiento
    </Title>
    <Spacing top={4}>
      <Text className="text-gray-500 leading-snug">
        Proporciónenos sus datos para descargar el programa oficial
        del entrenamiento más completo para hispanohablantes.
      </Text>
    </Spacing>
    <Spacing top={6}>
      <Spacing bottom={4}>
        <Container className="w-12 h-12 rounded-full bg-gray-200 overflow-hidden select-none">
          <img
            alt={constants.testimonial.name}
            className="rounded-full w-full h-full"
            src={`/assets/img/${constants.testimonial.picture}`}
          />
        </Container>
      </Spacing>
      <Spacing bottom={4}>
        <Text>
          {`«${constants.testimonial.text}»`}
        </Text>
      </Spacing>
      <Text className="text-sm font-medium text-gray-400">
        {`${constants.testimonial.name}, ${constants.testimonial.country}`}
      </Text>
      <Text className="text-xs font-medium text-gray-400">
        {constants.testimonial.position}
      </Text>
    </Spacing>
  </Flex>
);

export default DownloadProgramSocialProof;
